<template>
  <div>
    <div class="columns is-gapless" v-if="step === STEPS.ENTITY_SELECTION">
      <div class="column">
        <div class="field">
          <div class="control is-border has-icons-right" id="filtername">
            <input ref="input"
              type="text" class="input is-light" v-model="input" @input="startSearch"
              placeholder="Rechercher vendeur, socitété, pôle..."
              :class="{'is-degrad-info has-text-white':input && input.length}">
            <span class="icon is-right is-size-3">
              <i class="fal fa-search"></i>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="columns" v-if="step === STEPS.ENTITY_SELECTION">
      <div class="column is-paddingless inner-scroll liste-users">
        <ul>
          <li v-if="isAdmin" class="columns is-vcentered column is-paddingless is-border-bottom">
            <div class="column is-narrow is-padding-top-xsmall is-padding-bottom-xsmall">
               <span class="avatar avatar-01">
                 <span><b>&#8734;</b></span>
              </span>
            </div>
            <div class="column is-padding-top-xsmall is-padding-bottom-xsmall
              is-paddingless-left is-paddingless-right is-size-4 is-overflow-hidden
              is-nowrap hover-degrad">
              Tout les utilisateurs<br>
            </div>
            <div class="column is-narrow actions is-padding-top-xsmall is-padding-bottom-xsmall">
              <a @click="removeTarget('ALL')" v-if="targets.includes('ALL')" class="button is-circle is-primary">
                <span class="icon is-small"><i class="fal fa-check"></i></span>
              </a>
              <a @click="setTarget('ALL')" v-else class="button is-circle is-light">
                <span class="icon is-small"><i class="fal fa-plus"></i></span>
              </a>
            </div>
          </li>
          <li class="columns is-vcentered column is-paddingless is-border-bottom">
            <div class="column is-narrow is-padding-top-xsmall is-padding-bottom-xsmall">
               <span class="avatar avatar-02">
                <span><b>{{$configs.COMPANY[0]}}</b></span>
              </span>
            </div>
            <div class="column is-padding-top-xsmall is-padding-bottom-xsmall
              is-paddingless-left is-paddingless-right is-size-4 is-overflow-hidden
              is-nowrap hover-degrad">
              {{$configs.COMPANY}}<br>
            </div>
            <div class="column is-narrow actions is-padding-top-xsmall is-padding-bottom-xsmall">
              <a @click="removeTarget('INTERNALS')" v-if="targets.includes('INTERNALS')"
                 class="button is-circle is-primary">
                <span class="icon is-small"><i class="fal fa-check"></i></span>
              </a>
              <a @click="setTarget('INTERNALS')" v-else class="button is-circle is-light">
                <span class="icon is-small"><i class="fal fa-plus"></i></span>
              </a>
            </div>
          </li>
          <li v-if="isAdmin" class="columns is-vcentered column is-paddingless is-border-bottom">
            <div class="column is-narrow is-padding-top-xsmall is-padding-bottom-xsmall">
               <span class="avatar avatar-02">
                <span><b>P&C</b></span>
              </span>
            </div>
            <div class="column is-padding-top-xsmall is-padding-bottom-xsmall
              is-paddingless-left is-paddingless-right is-size-4 is-overflow-hidden
              is-nowrap hover-degrad">
              Partenaires & Collaborateurs<br>
            </div>
            <div class="column is-narrow actions is-padding-top-xsmall is-padding-bottom-xsmall">
              <a @click="removeTarget('EXTERNALS')" v-if="targets.includes('EXTERNALS')"
                 class="button is-circle is-primary">
                <span class="icon is-small"><i class="fal fa-check"></i></span>
              </a>
              <a @click="setTarget('EXTERNALS')" v-else class="button is-circle is-light">
                <span class="icon is-small"><i class="fal fa-plus"></i></span>
              </a>
            </div>
          </li>
          <li class="columns is-vcentered column is-paddingless is-border-bottom" v-for="(r, i) in results"
              :key="r.pk">
            <div class="column is-narrow is-padding-top-xsmall is-padding-bottom-xsmall">
               <span class="avatar" v-if="r.picture && r.picture.path">
                 <img :src="r.picture | avatar">
               </span>
              <span v-else class="avatar" :class="'avatar-0' + ((i % 6) + 1)">
                <span v-if="r.first_name && r.last_name">{{r.last_name[0] | cap}}{{r.first_name[0] | cap}}</span>
                <span v-else>{{r.name[0] | cap}}</span>
              </span>
            </div>
            <div
              class="column is-padding-top-xsmall is-padding-bottom-xsmall is-paddingless-left is-paddingless-right is-size-5 is-overflow-hidden is-nowrap hover-degrad">
              {{r.name}}<br>
              <span class="has-text-grey is-size-6">{{r.key | prettyKey}}</span>&nbsp;
              <span class="has-text-black is-size-7" v-if="r.company_name">{{r.company_name}}</span>
            </div>
            <div class="column is-narrow actions is-padding-top-xsmall is-padding-bottom-xsmall">
              <a @click="unselectEntity(r)" v-if="entitiesPk.includes(r.pk)" class="button is-circle is-success">
                <span class="icon is-small"><i class="fas fa-check"></i></span>
              </a>
              <a @click="selectEntity(r)" v-else class="button is-circle is-light">
                <span class="icon is-small"><i class="fal fa-plus"></i></span>
              </a>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="" v-if="step === STEPS.EVENT_FORM">
      <div class="columns is-multiline">
        <div class="column is-12 is-paddingless-bottom">
          <v-input id="title" name="title" @input="val => title = val" :model="title"
                   label="Titre *"
                   v-validate="'required|min:2'" :errors-bag="errors" data-vv-value-path="val"
                   data-vv-as="Titre">
          </v-input>
        </div>

        <div class="column is-12 is-paddingless-bottom">
          <label class="label">Description *</label>
          <textarea id="description" name="description" class="textarea" v-model="description"
                    label="Description *" data-vv-as="Description"
                    v-validate="'required|min:2'">
              </textarea>
        </div>

        <div class="column is-12 is-paddingless-bottom">
          <v-input id="link" name="link" @input="val => link = val" :model="link"
                   label="Lien"
                   v-validate="'min:2'" :errors-bag="errors" data-vv-value-path="val"
                   data-vv-as="Lien">
          </v-input>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { EntityMx } from '@/mixins'
  import { mapGetters } from 'vuex'
  import { bus, EVENTS } from '@/services/bus/index.js'

  const STEPS = {
    ENTITY_SELECTION: 'ENTITY_SELECTION',
    EVENT_FORM: 'EVENT_FORM'
  }
  export default {
    name: 'NewGlobalEvent',
    mixins: [EntityMx],
    props: {},
    data () {
      return {
        title: null,
        description: null,
        link: null,
        STEPS: STEPS,
        step: STEPS.ENTITY_SELECTION,
        selectedTarget: null,
        targets: [],
        algoliaKeys: ['USER', 'COMPANY', 'POLE']
      }
    },
    mounted: function () {
      this.$refs.input.focus()
    },
    computed: {
      ...mapGetters(['isAdmin', 'isOperator']),
      hasTarget () {
        return this.companies.length > 0 || this.users.length > 0 || this.targets.length > 0 || this.poles.length > 0
      },
      canSubmit () {
        if (this.step === STEPS.ENTITY_SELECTION) {
          return this.hasTarget === true
        }
        if (this.step === STEPS.EVENT_FORM) {
          return this.errors.any() === false
        }
        return false
      },
      users () {
        return this.entities.filter(x => {
          return x.key === 'USER'
        }).map(x => {
          return x.pk
        })
      },
      companies () {
        return this.entities.filter(x => {
          return x.key === 'COMPANY'
        }).map(x => {
          return x.pk
        })
      },
      poles () {
        return this.entities.filter(x => {
          return x.key === 'POLE'
        }).map(x => {
          return x.pk
        })
      }
    },
    methods: {
      setTarget (target) {
        this.targets.push(target)
      },
      removeTarget (target) {
        const index = this.targets.indexOf(target)
        if (index > -1) {
          this.targets.splice(index, 1)
        }
      },
      submit () {
        if (!this.canSubmit) {
          if (this.hasTarget === false) {
            this.$notify({
              type: 'is-danger',
              text: 'Vous devez selectioner au moins un destinataire.'
            })
          }
          return
        }
        if (this.step === STEPS.ENTITY_SELECTION) {
          this.step = STEPS.EVENT_FORM
          return
        }
        this.$validator.validateAll()
          .then(isValid => {
            if (isValid) {
              bus.$emit(EVENTS.LOADING, true)
              let notif = {
                targets: this.targets,
                companies: this.companies,
                poles: this.poles,
                users: this.users,
                title: this.title,
                description: this.description,
                link: this.link
              }
              this.$notify({
                type: 'is-info',
                text: 'Envoi en cours...'
              })
              this.$api.eventService.post(notif).then(r => {
                this.$notify({
                  type: 'is-info',
                  text: 'Notification(s) envoyées !'
                })
                this.$emit('submit', {})
                bus.$emit(EVENTS.LOADING)
              }).catch(() => {
                bus.$emit(EVENTS.LOADING)
                return console.error
              })
              // this.$emit('submit', {entities: this.entities})
            } else {
              this.$notify({
                type: 'is-danger',
                text: 'Oups ! Merci de compléter les champs obligatoires.'
              })
            }
          })
      }
    }
  }
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/quickview/NewGlobalEvent.vue